import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

// Hoşgeldin Popup:
// - Admin panelde (Platform Yönetimi) bir görsel yüklenmişse loginSettings.welcomePopup dolu gelir.
// - Kullanıcının SADECE ilk girişinde gösterilir. İlk giriş tespiti SUNUCU tarafındadır
//   (auth_user.welcome_popup_seen). Durum sorgusu ve "görüldü" işareti artık BU BİLEŞENDE DEĞİL,
//   App.js'teki PostLoginModals orchestrator'ındadır: aynı bayrak satış temsilcisi kodu popup'ı
//   ile PAYLAŞILIR (ikisi için ayrı kolon açılmaz).
// Sözleşme (CommercialConsentModal ile aynı, sıra orchestrator'da belirlenir):
//  - enabled: true olana kadar bekler (önceki modal — izin onayı — çözülene dek).
//  - firstLogin: null = henüz bilinmiyor, true/false = kullanıcının ilk girişi mi?
//  - onShown: popup gerçekten gösterildiğinde çağrılır (ilk-giriş bayrağını kapatmak için).
//  - onResolved: popup akışı bittiğinde (gösterilmeyecekse ya da kapatıldığında) bir kez çağrılır.
const WelcomePopup = ({ enabled = true, firstLogin = null, onShown, onResolved }) => {
  const isAuthenticated = useSelector((store) => store.auth.isAuthenticated);
  const welcomePopup = useSelector(
    (store) => store.auth.loginSettings?.welcomePopup
  );
  // Sorumluluk Reddi (disclaimer) durumu: popup, disclaimer akışından SONRA çıkmalı.
  const disclaimerInitialized = useSelector(
    (store) => store.disclaimer.initialized
  );
  const disclaimerRequired = useSelector((store) => store.disclaimer.required);

  const [show, setShow] = useState(false);
  // Aynı oturumda durum sorgusunun tekrar tekrar çalışmasını engeller.
  const checkedRef = useRef(false);
  // onResolved yalnızca bir kez tetiklensin.
  const resolvedRef = useRef(false);
  const resolve = () => {
    if (resolvedRef.current) return;
    resolvedRef.current = true;
    if (onResolved) onResolved();
  };

  useEffect(() => {
    if (!isAuthenticated || !enabled || checkedRef.current) return;
    // Görsel yüklenmemişse popup hiç açılmayacak → sıradaki modala hemen devret.
    if (!welcomePopup) {
      checkedRef.current = true;
      resolve();
      return;
    }
    // Disclaimer henüz çözülmediyse (initialized değil) ya da hâlâ zorunluysa bekle;
    // yalnızca disclaimer tamamlandığında (required === false) popup'ı göster.
    if (!disclaimerInitialized || disclaimerRequired !== false) return;
    // İlk-giriş durumu henüz gelmediyse bekle (orchestrator sorar).
    if (firstLogin === null) return;
    checkedRef.current = true;

    if (firstLogin === true) {
      setShow(true);
      // Gösterildiği anda "görüldü" işaretlensin ki bir daha açılmasın
      // (kullanıcı kapatmadan çıksa bile tekrar gösterilmez).
      if (onShown) onShown();
    } else {
      // Gösterilmeyecek → sıradaki modala devret.
      resolve();
    }
  }, [isAuthenticated, enabled, welcomePopup, disclaimerInitialized, disclaimerRequired, firstLogin]);

  const handleClose = () => {
    setShow(false);
    resolve();
  };

  if (!show || !welcomePopup) return null;

  return (
    <div
      onClick={handleClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          width: "600px",
          maxWidth: "90vw",
          maxHeight: "90vh",
        }}
      >
        <button
          type="button"
          aria-label="Kapat"
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "-14px",
            right: "-14px",
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#fff",
            color: "#333",
            fontSize: "18px",
            lineHeight: "34px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          }}
        >
          <i className="fas fa-times"></i>
        </button>
        <img
          src={welcomePopup}
          alt="Hoşgeldiniz"
          style={{
            display: "block",
            width: "100%",
            height: "auto",
            maxHeight: "90vh",
            objectFit: "contain",
            borderRadius: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default WelcomePopup;
